import type { BusinessUnit } from '@backend/lib-l10n';

import { getEnv } from '~/utils/env';

export function getDomainPublicURL(businessUnit: BusinessUnit): string {
  return getEnv(`NEXT_PUBLIC_PUBLIC_WEBSITE_URL_${businessUnit}`, 'https://iziwork.com');
}
